export default __webpack_public_path__ + "static/project-slide-2-4032-2268-15d8c9bc2033c0233def5871a260c8ce.webp";